module.exports = __webpack_public_path__ + "img/incidents.04b8377b.jpg";